/** Page-local formatters for the Stats pages (A7Y-4883). */

const INT = new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 });

export function formatInt(n: number): string {
  return INT.format(Number.isFinite(n) ? n : 0);
}

/** `part / whole` as a percentage with one decimal; an empty whole has no share. */
export function formatPct(part: number, whole: number): string {
  if (!Number.isFinite(part) || !Number.isFinite(whole) || whole <= 0) return '—';
  return `${((part / whole) * 100).toFixed(1)}%`;
}

/** An ISO instant as `YYYY-MM-DD HH:mm UTC`; an unparseable value is shown as received. */
export function formatUtcInstant(iso: string): string {
  const t = Date.parse(iso);
  if (Number.isNaN(t)) return iso;
  return `${new Date(t).toISOString().slice(0, 16).replace('T', ' ')} UTC`;
}

/**
 * A byte count in decimal (1000-based) units, the unit the Overview's stored-asset figures are quoted in
 * (A7Y-5020). Not `audit-spend/format.formatBytes`, which divides by 1024 and so prints a smaller number
 * than the decimal total the ticket quotes.
 */
export function formatBytesDecimal(bytes: number): string {
  if (!Number.isFinite(bytes) || bytes < 0) return '—';
  const units = ['B', 'KB', 'MB', 'GB', 'TB'];
  let n = bytes;
  let i = 0;
  while (n >= 1000 && i < units.length - 1) {
    n /= 1000;
    i += 1;
  }
  return i === 0 ? `${formatInt(n)} B` : `${n.toFixed(1)} ${units[i]}`;
}
